// extracted by mini-css-extract-plugin
export var resourceTileList = "R_cT";
export var resourceTileListContainer = "R_cV";